import 'jquery';

export const animateMultipageForms = (() => {
	const instance = {
		formSelector: undefined,
		pagePrefix: undefined,
		activePage: 1,
	};
	
	const activePage = 'gform_page--active';

	instance.init = () => {
		jQuery(document).on('gform_post_render', function(e, formId, currentPage){

			instance.formSelector = `#gform_wrapper_${formId}`;
			instance.pagePrefix = `#gform_page_${formId}`;

			const pageSelector = `${instance.pagePrefix}_${currentPage}`;

			const errors = document
				.querySelectorAll(`${instance.formSelector} .gform_validation_errors`);

				console.log(errors.length)
			if(errors.length)
			{
				instance.showPage(`${instance.formSelector} ${pageSelector}`);
			}

			if(currentPage !== 1)
			{
				return;
			}
	
			instance.showPage(`${instance.formSelector} ${pageSelector}`);
		});

		jQuery(document).on('gform_page_loaded', function (e, formId, currentPage) {
			instance.pageLoaded(formId, currentPage);
		});
	}

	instance.pageLoaded = (formId, currentPage) => {
		const pageSelector = `${instance.pagePrefix}_${currentPage}`;

		if(!instance.formSelector || instance.formSelector === undefined) {
			return;
		}

		if(instance.activePage !== currentPage) {
			instance.hidePage(`${instance.formSelector} .gform_page`);

			instance.showPage(`${instance.formSelector} ${pageSelector}`);
			instance.activePage = currentPage;
		}
	}

	instance.showPage = (selector) => {
		const el = document.querySelector(`${selector}`);
		if (el) {
			setTimeout(() => {
				el.classList.add(activePage);
			}, 200);
		}
	}

	instance.hidePage = (selector) => {
		document.querySelector(`${selector}`)
			.classList
			.remove(activePage);
	}

	return instance;
})();



// WEBPACK FOOTER //
// ./scripts/modules/multipage-forms.js